import api from './api';
import { crudOperations } from './api';

class EstimateService {
  // Get estimates for a franchisee with pagination/filtering
  async getEstimates(franchiseeId, { page = 1, limit = 50, search, status, customer, sortBy = 'estimate_date', sortOrder = 'DESC' } = {}) {
    try {
      const params = { page, limit, sortBy, sortOrder };
      if (search) params.search = search;
      if (status) params.status = status;
      if (customer) params.customer = customer;

      const response = await crudOperations.get(`/estimates/${franchiseeId}`, params);
      return response.data;
    } catch (error) {
      console.error('Get estimates error:', error);
      throw error;
    }
  }

  // Get single estimate with line items
  async getEstimate(franchiseeId, estimateId) {
    try {
      const response = await crudOperations.get(`/estimates/${franchiseeId}/${estimateId}`);
      return response.data;
    } catch (error) {
      console.error('Get estimate error:', error);
      throw error;
    }
  }

  // Create new estimate
  async createEstimate(franchiseeId, estimateData) {
    try {
      const response = await crudOperations.post(`/estimates/${franchiseeId}`, estimateData);
      return response.data;
    } catch (error) {
      console.error('Create estimate error:', error);
      throw error;
    }
  }

  // Update estimate
  async updateEstimate(franchiseeId, estimateId, estimateData) {
    try {
      const response = await crudOperations.put(`/estimates/${franchiseeId}/${estimateId}`, estimateData);
      return response.data;
    } catch (error) {
      console.error('Update estimate error:', error);
      throw error;
    }
  }

  // Delete estimate
  async deleteEstimate(franchiseeId, estimateId) {
    try {
      const response = await crudOperations.delete(`/estimates/${franchiseeId}/${estimateId}`);
      return response.data;
    } catch (error) {
      console.error('Delete estimate error:', error);
      throw error;
    }
  }

  // Get estimates by job ID
  async getEstimatesByJob(franchiseeId, jobId) {
    try {
      const response = await crudOperations.get(`/estimates/${franchiseeId}/by-job/${jobId}`);
      return response.data;
    } catch (error) {
      console.error('Get estimates by job error:', error);
      throw error;
    }
  }

  // Get estimates by appointment ID
  async getEstimatesByAppointment(franchiseeId, appointmentId) {
    try {
      const response = await crudOperations.get(`/estimates/${franchiseeId}/by-appointment/${appointmentId}`);
      return response.data;
    } catch (error) {
      console.error('Get estimates by appointment error:', error);
      throw error;
    }
  }

  // View estimate PDF in new tab
  async viewPDF(franchiseeId, estimateId) {
    try {
      const response = await api.get(`/estimates/${franchiseeId}/${estimateId}/pdf`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
      console.error('View estimate PDF error:', error);
      throw error;
    }
  }

  // Get next estimate number
  async getNextEstimateNumber(franchiseeId) {
    try {
      const response = await crudOperations.get(`/estimates/next-number/${franchiseeId}`);
      return response.data;
    } catch (error) {
      console.error('Get next estimate number error:', error);
      throw error;
    }
  }

  // Format currency
  formatCurrency(amount) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(amount || 0);
  }

  // Format date
  formatDate(dateString) {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  // Get status color class
  getStatusColor(status) {
    const statusColors = {
      active: 'bg-green-100 text-green-800',
      declined: 'bg-red-100 text-red-800',
      expired: 'bg-orange-100 text-orange-800',
      converted: 'bg-purple-100 text-purple-800'
    };
    return statusColors[status] || 'bg-gray-100 text-gray-800';
  }
}

const estimateService = new EstimateService();
export default estimateService;
